module.exports = __webpack_public_path__ + "static/media/Carleton.371d214a.png";